/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/EmptyState
 * @desc Empty state for experiment workflows
 */

import { ExperimentWorkflowActionCreateTemplate } from 'labstep-web/components/ExperimentWorkflow/Action/CreateTemplate';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';
import type { ExperimentWorkflowEmptyStateProps } from './types';

export const ExperimentWorkflowTemplateEmptyState: React.FC<
  ExperimentWorkflowEmptyStateProps
> = (props) => (
  <CardEmptyState
    title={`No ${ExperimentWorkflow.getHumanReadableEntityName(
      true,
      true,
      true,
    )}`}
    explanation="Use templates to ensure a consistent structure to your entries or to save time documenting common workflows."
    src="/img/empty-state/experiments.svg"
    action={<ExperimentWorkflowActionCreateTemplate />}
    {...props}
  />
);
